<ng-container *ngIf="documentStatus$ | async as documentStatus">
	<ng-container
		*ngIf="documentStatus !== DOCUMENT_STATUSES.READY; else documentView"
	>
		<div class="flex flex-col w-full h-full justify-center items-center gap-5">
			<div class="w-20">
				<img src="assets/images/empty-states/doc-loading.gif" />
			</div>
			<span *ngIf="documentStatus === DOCUMENT_STATUSES.INITIALIZING"
				>Initializing document</span
			>
			<span *ngIf="documentStatus === DOCUMENT_STATUSES.UPDATING"
				>Updating document</span
			>
		</div>
	</ng-container>
</ng-container>

<ng-template #documentView>
	<div class="h-full grid relative">
		<div
			class="flex justify-end h-10 items-center gap-2 top-[5px] right-0 absolute px-4"
		>
			<ui-button
				icon="printer"
				preset="EXTRA_LOW_EMPHASIS"
				(click)="print()"
				size="sm"
				label="Print"
				[testHook]="testHooks.PrintButton"
			></ui-button>
			<ui-button
				icon="copy"
				preset="EXTRA_LOW_EMPHASIS"
				(click)="copyBodyContent()"
				size="sm"
				label="Copy"
				[testHook]="testHooks.CopyButton"
			></ui-button>
			<ui-button
				icon="file-type-pdf"
				preset="EXTRA_LOW_EMPHASIS"
				(click)="downloadPDF()"
				size="sm"
				label="PDF"
				[testHook]="testHooks.DownloadButton"
			></ui-button>
			<button
				class="bg-white ring-gray-200 text-gray-500 active:bg-gray-200 active:text-gray-700 hover:bg-gray-200 hover:text-gray-700 duration-300 relative ring-1 ring-inset flex items-center gap-1 p-1.5 pr-3 rounded-md text-sm min-h-[32px] justify-center"
				(click)="exportToWord()"
				[disabled]="wordDownloadStatus$ | async"
				[loading]="wordDownloadStatus$ | async"
				[ngClass]="{
					'pointer-events-none': wordDownloadStatus$ | async,
				}"
				[testHook]="testHooks.WordButton"
			>
				<div
					class="w-5 h-5 flex items-center justify-center rounded-[4px]"
					[ngClass]="{
						'bg-gray-200': wordDownloadStatus$ | async,
						'bg-wordDocumentBlue': !(wordDownloadStatus$ | async),
					}"
				>
					<svg
						*ngIf="!(wordDownloadStatus$ | async); else openingIcon"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 50 50"
						width="14px"
						height="14px"
						class="fill-white"
					>
						<path
							d="M 28.8125 0.03125 L 0.8125 5.34375 C 0.339844 5.433594 0 5.863281 0 6.34375 L 0 43.65625 C 0 44.136719 0.339844 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 28.875 49.980469 28.9375 50 29 50 C 29.230469 50 29.445313 49.929688 29.625 49.78125 C 29.855469 49.589844 30 49.296875 30 49 L 30 1 C 30 0.703125 29.855469 0.410156 29.625 0.21875 C 29.394531 0.0273438 29.105469 -0.0234375 28.8125 0.03125 Z M 32 6 L 32 13 L 44 13 L 44 15 L 32 15 L 32 20 L 44 20 L 44 22 L 32 22 L 32 27 L 44 27 L 44 29 L 32 29 L 32 35 L 44 35 L 44 37 L 32 37 L 32 44 L 47 44 C 48.101563 44 49 43.101563 49 42 L 49 8 C 49 6.898438 48.101563 6 47 6 Z M 4.625 15.65625 L 8.1875 15.65625 L 10.21875 28.09375 C 10.308594 28.621094 10.367188 29.355469 10.40625 30.25 L 10.46875 30.25 C 10.496094 29.582031 10.613281 28.855469 10.78125 28.0625 L 13.40625 15.65625 L 16.90625 15.65625 L 19.28125 28.21875 C 19.367188 28.679688 19.433594 29.339844 19.5 30.21875 L 19.53125 30.21875 C 19.558594 29.53125 19.632813 28.828125 19.75 28.125 L 21.75 15.65625 L 25.0625 15.65625 L 21.21875 34.34375 L 17.59375 34.34375 L 15.1875 22.375 C 15.058594 21.75 14.996094 21.023438 14.96875 20.25 L 14.9375 20.25 C 14.875 21.101563 14.769531 21.824219 14.65625 22.375 L 12.1875 34.34375 L 8.4375 34.34375 Z"
						/>
					</svg>

					<ng-template #openingIcon>
						<i-tabler
							name="loader-2"
							class="w-3 h-3 text-gray-500 animate-spin"
						></i-tabler>
					</ng-template>
				</div>
				<span class="text-sm">Word</span>
			</button>
		</div>
		<app-pdftron
			#pdfViewer
			[blob]="pdf$ | async"
			[fileName]="fileName || viewingDocument?.document?.title"
			(documentLoaded)="documentLoaded()"
			(finishedRendering)="finishedRendering()"
			[disabledElements]="disabledElements"
		></app-pdftron>
	</div>
</ng-template>
